// lemmatagutils.js
import React,{ useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LocalStorageUtil from './LocalStorageUtil';
import './UserDashTagUtilStyle.css'; // Import the CSS file
export const WordTagControls = ({baseHostUrl }) => {
    const navigate = useNavigate();
  const [newTag, setNewTag] = React.useState('');
  const session = LocalStorageUtil.getSession();
  const userTags = session?.usrprofile?.wordtags || [];
  const [confirmDeleteTag, setConfirmDeleteTag] = useState(null); // stores tag being confirmed

  const updateProfile = async (updatedProfile,action,tag='') => {
    try {
        ////this is for tag list operation
      await axios.post(`${baseHostUrl}/update-profile-tag-${action}`, {
        username: session.username,
        usrprofile: updatedProfile,
        extra: tag  // the tag to remove
      }, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      });
      const updatedSession = { ...session, usrprofile: updatedProfile };
      LocalStorageUtil.saveSession(updatedSession);
    // ✅ Force reload of just the component (not the whole page)
    navigate('/dashboard');
    //window.location.reload(); // ⛔ full reload (your current setup)
    } catch (err) {
      alert("Failed to update user profile");
    }
  };

  const handleAddTag = () => {
    const trimmed = newTag.trim().toLowerCase();
    if (!trimmed || trimmed === 'notag'|| trimmed === 'all') {
      alert(`"${trimmed}" is not a valid tag name.`);
      return;
    }
    const updatedTags = [...new Set([...userTags, newTag.trim()])];
    if (updatedTags.length > 5) {
        alert("You can only have up to 5 word tags.");
        return;
      }
    const updatedProfile = { ...session.usrprofile, wordtags: updatedTags };
    updateProfile(updatedProfile,'add');
    setNewTag('');
  };

  const handleDeleteClick = (tag) => {
    setConfirmDeleteTag(tag); // Show the modal for this tag
  };
  
  const handleConfirmDelete = async () => {
    await handleDeleteTag(confirmDeleteTag); // existing logic to remove tag
    setConfirmDeleteTag(null); // hide modal
  };
  
  const handleCancelDelete = () => {
    setConfirmDeleteTag(null); // close modal
  };

  const handleDeleteTag = (tag) => {
    const updatedTags = userTags.filter(t => t !== tag);
    let updatedProfile = { ...session.usrprofile, wordtags: updatedTags };
    if (session.usrprofile.wordtag === tag) {
      updatedProfile.wordtag = updatedTags[0] || '';
    }
    updateProfile(updatedProfile,'del',tag);
  };

  const handleSetDefault = (tag) => {
    const updatedProfile = { ...session.usrprofile, wordtag: tag };
    updateProfile(updatedProfile,'set');
  };

  return (
    <div className="db-learns-wrapper">
      <h4 className="db-learns-title">Your Word Lists</h4>
      <ul className="db-learns-list">
        {userTags.map((tag, index) => (
          <li key={index} className="db-learns-item">
            📘 {tag}
            {session.usrprofile.wordtag === tag && (
              <span className="db-default-badge ">default</span>
            )}
            {session.usrprofile.wordtag !== tag && (
                <button onClick={() => handleSetDefault(tag)}>Set Default</button>
            )}

            {session.usrprofile.wordtag === tag ? (
                <span className="db-tag-locked">🔒</span>
                ) : (
                <button
                    className="db-tag-btn db-tag-delete"
                    onClick={() => handleDeleteClick(tag)}
                >
                    ❌
                </button>
            )}

            {/* <button onClick={() => handleDeleteClick(tag)}>❌</button> */}
          </li>
        ))}
      </ul>
      {confirmDeleteTag && (
        <div className="db-confirm-modal">
            <div className="db-confirm-box">
            <p>⚠️ This will delete <strong>{confirmDeleteTag}</strong> and all words tagged with it. Continue?</p>
            <div className="db-confirm-buttons">
                <button onClick={handleConfirmDelete}>✅ Yes</button>
                <button onClick={handleCancelDelete}>❌ No</button>
            </div>
            </div>
        </div>
        )}
      <input
        type="text"
        value={newTag}
        onChange={(e) => setNewTag(e.target.value)}
        placeholder="New tag name"
      />
      <button onClick={handleAddTag}>Add</button>
    </div>
  );
};
